module.exports = __webpack_public_path__ + "img/intro_text1_right.0be7de57.png";